module.exports = __webpack_public_path__ + "img/9c1f6002abf149f550ae6395e829c624.gif";